import React from 'react';
export default function useDrag() {
    var _a = React.useState(false), clicked = _a[0], setClicked = _a[1];
    var _b = React.useState(false), dragging = _b[0], setDragging = _b[1];
    var position = React.useRef(0);
    var dragStart = React.useCallback(function (ev) {
        position.current = ev.clientX;
        setClicked(true);
    }, []);
    var dragStop = React.useCallback(function () {
        // NOTE: need some delay so item under cursor won't be clicked
        return window.requestAnimationFrame(function () {
            setDragging(false);
            setClicked(false);
        });
    }, []);
    var dragMove = function (ev, cb) {
        var newDiff = position.current - ev.clientX;
        var movedEnough = Math.abs(newDiff) > 5;
        if (clicked && movedEnough) {
            setDragging(true);
        }
        if (dragging && movedEnough) {
            position.current = ev.clientX;
            cb(newDiff);
        }
    };
    return {
        dragStart: dragStart,
        dragStop: dragStop,
        dragMove: dragMove,
        dragging: dragging,
        position: position,
        setDragging: setDragging,
    };
}
